PegasusTemplate.MainTabPanelView = Em.View.extend({
  classNames: [ 'sidebar'],

  templateName: 'main_tab_panel'
});
